import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import CustomerBundelsTable from "pages/admin/Customers/components/CustomerBundelsTable"
import { useTranslation } from "react-i18next"

export interface Customer {
  customerName: string
  id: string
  couponConsumptionRate: string
  area: string
  preferredPerWeek: string
  received: string
  status: "Active" | "In Active"
}

export const customersData: Customer[] = [
  {
    customerName: "Ahmed Ali",
    id: "ID-145876",
    couponConsumptionRate: "40%",
    area: "Doha",
    preferredPerWeek: "8 Bundle",
    received: "6 Bundle",
    status: "Active",
  },
  {
    customerName: "Emily Davis",
    id: "ID-145881",
    couponConsumptionRate: "30%",
    area: "Al Rayyan",
    preferredPerWeek: "5 Bundle",
    received: "8 Bundle",
    status: "In Active",
  },
  {
    customerName: "Maria Garcia",
    id: "ID-145879",
    couponConsumptionRate: "75%",
    area: "Al Wakrah",
    preferredPerWeek: "15 Bundle",
    received: "3 Bundle",
    status: "Active",
  },
  {
    customerName: "James Brown",
    id: "ID-145880",
    couponConsumptionRate: "90%",
    area: "Doha",
    preferredPerWeek: "20 Bundle",
    received: "2 Bundle",
    status: "Active",
  },
  {
    customerName: "Sofia Kim",
    id: "ID-145877",
    couponConsumptionRate: "65%",
    area: "Al Khor",
    preferredPerWeek: "12 Bundle",
    received: "4 Bundle",
    status: "Active",
  },
  {
    customerName: "Liam Smith",
    id: "ID-145878",
    couponConsumptionRate: "50%",
    area: "Al Rayyan",
    preferredPerWeek: "10 Bundle",
    received: "5 Bundle",
    status: "In Active",
  },
  {
    customerName: "Ahmed Ali",
    id: "ID-145870",
    couponConsumptionRate: "40%",
    area: "Doha",
    preferredPerWeek: "8 Bundle",
    received: "6 Bundle",
    status: "Active",
  },
]

export const CustomersBundles = () => {
  const { t } = useTranslation()

  const [checkedCustomers, setCheckedCustomers] = useState<Customer[]>([])
  const [customers, setCustomers] = useState<Customer[]>([])

  useEffect(() => {
    setCustomers(customersData)
  }, [])

  const isAllChecked = useMemo(() => {
    return customers.length > 0 && checkedCustomers.length === customers.length
  }, [customers, checkedCustomers])

  const togglecheckedCustomerHandler = useCallback((customer: Customer) => {
    setCheckedCustomers(prev =>
      prev.includes(customer)
        ? prev.filter(c => c !== customer)
        : [...prev, customer]
    )
  }, [])

  const toggleAllCustomers = useCallback(() => {
    setCheckedCustomers(isAllChecked ? [] : customers)
  }, [isAllChecked, customers])

  const toggleActiveCustomer = useCallback(
    (customer: Customer) => {
      setCustomers(prev =>
        prev.map(c =>
          c.id === customer.id
            ? {
                ...c,
                status: c.status === "Active" ? "In Active" : "Active",
              }
            : c
        )
      )
    },
    [customers]
  )

  return (
    <div className="page-content">
      <Breadcrumbs
        title={t("dashboard_dashboard")}
        breadcrumbItem={t("customers_customers")}
        subBreadcrumbItem={t("customers_customersBundles")}
      />
      <div className="container-fluid">
        <CustomerBundelsTable
          customers={customers}
          isAllChecked={isAllChecked}
          checkedCustomers={checkedCustomers}
          toggleAllCustomers={toggleAllCustomers}
          toggleActiveCustomer={toggleActiveCustomer}
          togglecheckedCustomerHandler={togglecheckedCustomerHandler}
        />
      </div>
    </div>
  )
}
